import Cookies from 'js-cookie';
import message from 'antd/lib/message';

import logout from '../logout';
import fetch from '../fetch';

import { ENV_CONFIG } from '@laigu/constants';
const configFetch = props => {
  const { ignoreLogin, ...fetchProps } = props;
  const isUploadImg = fetchProps.isUploadImage;
  const isDevTranslate = fetchProps.isDevTranslate;
  return new Promise((resolve, reject) => {
    let newProps = { ...fetchProps };
    const { headers = {} } = fetchProps;
    const token = Cookies.get('_authenticated');
    if (token && fetchProps.type !== 'file' && !headers.Authorization) {
      headers.Authorization = token;

      if (window.CAFE_API_URL && props.baseURL === window.CAFE_API_URL) {
        headers['X-Cafe-EntToken'] = localStorage.getItem('_enterprise_token');
        headers['X-Cafe-OrgId'] = ENV_CONFIG.MQ_ORG_ID;
        headers['X-Cafe-AgentId'] = Cookies.get('_agent_id');
      }

      newProps = {
        ...newProps,
        headers
      };
      if (isDevTranslate) {
        newProps = { ...fetchProps };
      }
    }
    message.config({
      top: 24
    });
    fetch(newProps)
      .then(data => {
        resolve(data);
      })
      .catch(e => {
        let messageStr;
        // 主动取消的请求：不提示，直接抛给调用方自行忽略
        if (e?.__CANCELED__) {
          reject(e);
          return;
        }
        if (e.status === 401 && !ignoreLogin) {
          logout();
          return false;
        }
        if (e === 'Error: Network Error') {
          // messageStr = '网络无法连接，请检查您的网络，连接正常后再试。';
          messageStr = null;
        }
        if (e.status === 499 || e.status === 504) {
          messageStr = '操作没有响应，请稍候再试。';
        }
        if (e.status === 502) {
          messageStr = '服务器错误，请重试，如需帮助请联系我们。';
        }
        if (e.status === 429) {
          messageStr = '请求太频繁，请等等再试。';
        }
        if (e?.data?.message) {
          messageStr = e.data.message;
        }
        if (e?.data?.error?.message) {
          messageStr = e.data.error.message;
        }
        if (isUploadImg) {
          messageStr = '';
        }
        if (messageStr) {
          message.config({
            top: 60
          });
          message.warn({ content: messageStr, key: 'error_message' });
        }
        reject(e);
      });
  });
};

export default configFetch;
